import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import { BlurryBox } from '~Components/LinkUser/styles';

const DetailWrapper = styled(Box)`
  flex: 1;
  background-color: var(--colorBlueGray1100);
  border-radius: 8px;
  border: 1px solid var(--colorBlueGray700);
  padding: 24px;
  align-self: flex-start;
`;

/** Loading skeleton for the member details panel, shown before a member is selected */
const MemberDetailsSkeleton: FC = () => {
  return (
    <DetailWrapper display="flex" flexDirection="column" gap="small">
      <BlurryBox width="60px" height="18px" />

      <Box display="flex" flexDirection="column" gap="xs" fluid>
        <Box display="flex" flexDirection="column" fluid>
          <Box
            fluid
            display="flex"
            gap="xs"
            alignItems="flex-start"
            justifyContent="space-between">
            <Box display="flex" flexDirection="column" gap="xs">
              <BlurryBox width="180px" height="24px" />
              <BlurryBox width="200px" height="16px" />
            </Box>

            <Box display="flex" flexDirection="column" gap="xs">
              <BlurryBox width="100px" height="16px" />
              <BlurryBox width="80px" height="16px" />
            </Box>
          </Box>

          <Box display="flex" alignItems="center" marginTop="xs" gap="medium">
            <Box display="flex" gap="xs" alignItems="center" fluid>
              <BlurryBox width="16px" height="16px" />
              <BlurryBox width="150px" height="16px" />
            </Box>
            <Box display="flex" gap="xs" alignItems="center" fluid>
              <BlurryBox width="16px" height="16px" />
              <BlurryBox width="120px" height="16px" />
            </Box>
          </Box>
        </Box>
      </Box>
    </DetailWrapper>
  );
};

export default MemberDetailsSkeleton;
